import {
  StatementActivityType,
  type StatementActivity,
  type StatementHistoryItem,
} from "lib/api-types/schemas";

const PAYMENT_WINDOW_MS = 10_000;

export const paymentKey = (activity: StatementActivity) =>
  `${activity.date}|${activity.card?.amount ?? ""}|${activity.card?.cardLast4 ?? ""}`;

function paymentsOf(
  history: StatementHistoryItem[] | undefined,
  statementId: string,
) {
  const statement = history?.find((item) => item.statementId === statementId);
  const payments = (statement?.activities ?? []).filter(
    (activity) =>
      activity.type === StatementActivityType.PaymentReceived &&
      activity.date !== undefined,
  );
  return { statement, payments };
}

export function knownPaymentKeys(
  history: StatementHistoryItem[] | undefined,
  statementId: string | null,
): ReadonlySet<string> | null {
  if (!history || !statementId) return null;
  return new Set(paymentsOf(history, statementId).payments.map(paymentKey));
}

const distanceFrom = (activity: StatementActivity, paidAt: number) =>
  Math.abs(Date.parse(activity.date!) - paidAt);

export function findNewPayment(
  history: StatementHistoryItem[] | undefined,
  notice: {
    statementId: string | null;
    paidAt: number;
    knownPayments: ReadonlySet<string> | null;
  },
) {
  if (!notice.statementId) return undefined;

  const { statement, payments } = paymentsOf(history, notice.statementId);
  if (!statement) return undefined;

  const nearby = payments.filter(
    (activity) => distanceFrom(activity, notice.paidAt) <= PAYMENT_WINDOW_MS,
  );
  const [only] = nearby;
  const isKnown = !!only && !!notice.knownPayments?.has(paymentKey(only));

  return nearby.length === 1 && !isKnown
    ? { statement, amount: only.card?.amount ?? undefined }
    : undefined;
}
